import React from 'react';

function M2content() {
    return (
    <div id="mcontent2" className="row">
        <div className="container">
            <div className="row">
            <div id="bodycards" className="container">
                <div className="row">
                <div className="card-deck">
                    <div id="mcontent2b" className="card">
                    <div className="card-body">
                        <img className="img-fluid" src="images/tap.jpg" alt="Plumbing" />
                    </div>
                    </div>
                    <div id="mcontent2b" className="card">
                    <div className="card-body">
                        <img className="img-fluid" src="images/draincleaning.jpg" alt="Drain Cleaning" />
                    </div>
                    </div>
                    <div id="mcontent2b" className="card">
                    <div className="card-body">
                        <img className="img-fluid" src="images/waterheater.jpg" alt="Water Heater" />
                    </div>
                    </div>
                    <div id="mcontent2b" className="card">
                    <div className="card-body">
                        <img className="img-fluid" src="images/repiping.jpg" alt="Repiping" />
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    </div>


    );
}

export default M2content;